const state = () => ({
  selectedInsuranceCompany: null,
  tab: 0
});

const getters = {
  selectedInsuranceCompany(state) {
    return state.selectedInsuranceCompany;
  },
  tab(state) {
    return state.tab;
  }
};

const mutations = {
  setSelectedInsuranceCompany(state, payload) {
    state.selectedInsuranceCompany = payload;
  },
  setTab(state, payload) {
    state.tab = payload;
  }
};

const actions = {
  setTab({ commit }, payload) {
    commit('setTab', payload);
  }
};

export const healthInsuranceProviderBenefit = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
